import React, { Component } from 'react';
import useChangePageTitle from '../Dashboard/CustomHooks/useChangePageTitle';

const Support = () => {
  useChangePageTitle('Support');

  return <div></div>;
};
export default Support;
